import { Component, OnInit } from '@angular/core';
import { LoadingComponent, ToastService } from "@digi-america/shared";

import { UserRelationships, UserService } from '../../services/user.service';
import { firstValueFrom } from 'rxjs';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormGroupComponent } from '../product-editor/form-group.component';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile-manage',
  imports: [LoadingComponent, FormGroupComponent, ReactiveFormsModule, AsyncPipe, CommonModule],
  templateUrl: './profile-manage.component.html',
  styleUrl: './profile-manage.component.scss'
})
export class ProfileManageComponent implements OnInit {
  form!: FormGroup<any>;
  relationships$!: Promise<UserRelationships>;
  
  constructor(private userService: UserService, private fb: NonNullableFormBuilder, private toast: ToastService) { }

  async ngOnInit(): Promise<void> {
    this.relationships$ = firstValueFrom(this.userService.getMyRelationships());

    const user = await firstValueFrom(this.userService.getProfile());

    this.form = this.fb.group({
      title: this.fb.control(user.title ?? '', [Validators.maxLength(40)]),
      phone: this.fb.control(user.phone ?? '', [Validators.maxLength(20)])
    })
  }

  async submit(): Promise<void> {
    const userData = this.form.getRawValue();
    try {
      await firstValueFrom(this.userService.updateProfile({
        title: userData.title,
        phone: userData.phone
      }));

      this.toast.success("User Profile Updated!");
    }
    catch (e) {
      this.toast.error("Failed to update user profile.");
    }
  }
}
